import React, { useEffect, useMemo, useState } from "react";
import Select from "react-select";
import { customStylesForNewRegistration } from "./CustomSelectStyles";
import { DoctorCard } from "./DoctorCard";
import {
  getLookupByName,
  saveAppointmentData,
  savePatientData,
} from "../utils/api";
import { createOption, formattedDate } from "../utils/utilities";
import CustomToast from "./CustomToast";
import { toast } from "react-toastify";
import ReusableModal from "./ReusableModal";
import { useDispatch, useSelector } from "react-redux";
import { updateUHID } from "../Redux/Reducers/appointmentFilterSlice";
import PaymentModal from "./PaymentModal";
import AppointmentSuccess from "./AppointmentSuccess";
import { succesBtnSvg } from "../assets/svg";
import PaymentMobileComponent from "./PaymentMobileComponent";
function NewPatientForm({ setShowForm, showForm }) {
  const [stateLookupLinkName, setStateLookupLinkName] = useState("");
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    Title: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    patient_phone: "",
    gender: "",
    maritalStatus: "",
    DOB: "",
    mobileNo: "",
    email: "",
    address: "",
    country: "",
    state: "",
    district: "",
    area: "",
    pinCode: "",
    consent: false,
  });

  const selectedDateISOString = useSelector(
    (state) => state.appointment.selectedDate
  );

  const selectedDate = useMemo(
    () => new Date(selectedDateISOString),
    [selectedDateISOString]
  );
  const [dropdownOptions, setDropdownOptions] = useState({});
  const {
    selectedAppointment,
    selectedDoctor,
    selectedFacility,
    selectedSpecialization,
    uhid,
  } = useSelector((state) => state.appointment);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [isAppointmentSuccessful, setIsAppointmentSuccessful] = useState(false);

  const handleChange = (e) => {
    const name = e.target ? e.target.name : e.name;
    const value = e.target ? e.target.value : e.value;
    const checked = e.target ? e.target.checked : e;
    const type = e.target ? e.target.type : typeof e;

    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const validateForm = () => {
    const {
      Title,
      first_name,
      last_name,
      patient_phone,
      gender,
      DOB,
      email,
      address,
      country,
      state,
      district,
      consent,
    } = formData;

    const errors = {
      Title: !Title.trim() && "Title is required",
      first_name: !first_name.trim() && "First name is required",
      last_name: !last_name.trim() && "Last name is required",
      patient_phone:
        (!patient_phone.trim() && "Phone number is required") ||
        (!/^\d{10}$/.test(patient_phone) && "Invalid phone number"),
      gender: !gender.trim() && "Gender is required",
      DOB:
        (!DOB.trim() && "Date of birth is required") ||
        (new Date(DOB) > new Date() && "Date of birth cannot be in the future"),
      email:
        (!email.trim() && "Email is required") ||
        (!/\S+@\S+\.\S+/.test(email) && "Invalid email address"),
      address: !address.trim() && "Address is required",
      country: !country.trim() && "Country is required",
      state: !state.trim() && "State is required",
      district: !district.trim() && "City is required",
      consent: !consent && "Please agree to the Terms & Conditions",
    };

    return Object.entries(errors)
      .filter(([_, value]) => value)
      .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
  };
  //----Check errors from the top and then post the form. @Sanket
  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();

    if (Object.keys(errors).length === 0) {
      // Submit the form if no errors
      const body = {
        db_obj_name: "patient_registration",
        facility_id: selectedFacility.value,
        properties: {
          ...formData,
        },
      };
      const response = await savePatientData(body);
      console.log(response, "Response");
      if (response.statusCode === 200) {
        dispatch(updateUHID(response.uhr_id));
        toast.success(response.message);
        setIsModalOpen(true);
        setTimeout(() => {
          setShowPaymentModal(true);
          if (isMobile) {
            setShowForm("payment");
          }
        }, 3000);
      }
    } else {
      // Display errors if there are any
      Object.values(errors).forEach((error) => toast.error(error));
      console.log(errors);
    }
  };

  const handleBookAppointment = async () => {
    const saveBody = {
      tenant_id: sessionStorage.getItem("tenant_name"),
      facility_name: selectedFacility.label,
      facility_id: selectedFacility.value,
      appointment_date: formattedDate(selectedDate),
      appointment_time: selectedAppointment.time,
      appointment_slot_duration: selectedAppointment.duration,
      appointment_status: "Unconfirmed",
      provider_id: selectedDoctor.value,
      provider_name: selectedDoctor.label.slice(4),
      specialization: selectedSpecialization.label,
      reason_of_visit: "",
      mode_of_appointment: "Online",
      appointment_type: selectedAppointment.type,
      visit_type: "First",
      appointment_identification: selectedAppointment.identification,
      existing_patient: [
        {
          patient_id: uhid,
          patient_name: `${formData.first_name} ${formData.middle_name ?? ""} ${
            formData.last_name
          }`,
          mobile: formData.patient_phone,
          duration: null,
          patient_status: "Unconfirmed",
          visit_type: "First",
        },
      ],
      new_patient: [],
    };
    try {
      const response = await saveAppointmentData(saveBody);
      if (response.statusCode === 200) {
        setIsAppointmentSuccessful(true);
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  useEffect(() => {
    setDropdownOptions({
      Title: [
        { label: "Mr", value: "Mr", name: "Title" },
        { label: "Mrs", value: "Mrs", name: "Title" },
        { label: "Ms", value: "Ms", name: "Title" },
      ], // Fetch dropdown options here
      gender: [
        { label: "Male", value: "Male", name: "gender" },
        { label: "Female", value: "Female", name: "gender" },
      ],
      maritalStatus: [
        { label: "Single", value: "Single", name: "maritalStatus" },
        { label: "Married", value: "Married", name: "gender" },
        { label: "Widow", value: "Widow", name: "gender" },
      ],
      country: [
        { label: "India", value: "India", name: "country" },
        {
          label: "United States",
          value: "United States",
          name: "country",
        },
        {
          label: "United Arab Emirates",
          value: "United Arab Emirates",
          name: "country",
        },
      ],
      state: [],
      district: [],
    }); // Fetch dropdown options here
  }, []);
  const inputStyles = {
    width: "100%",
    height: "44px",
    padding: "5px",
    margin: "5px 0",
    borderRadius: "6px",
    border: "1px solid rgba(84, 100, 99, 1)",
  };
  const doctor = {
    name: "Dr. John Doe",
    speciality: "Cardiologist",
    experience: 10,
    facility: "Miracles Mediclinic, Sec 14 ",
    fee: 500,
    qualification: "MBBS, MD",
    opd_time: "10:00 AM - 1:00 PM",
    available_days: "Mon - Sat",
    isSelected: true,
  };
  useEffect(() => {
    const callLookupApi = async () => {
      const lookupData = await getLookupByName({ lookupName: "country" });
      setDropdownOptions((prevOptions) => ({
        ...prevOptions,
        country: lookupData?.map((item) =>
          createOption({ label: item.value, name: "country" })
        ),
      }));
    };

    callLookupApi();
  }, []);
  const isMobile = window.innerWidth <= 768;
  return (
    <div className="d-flex flex-column " style={{ width: "90%" }}>
      {/* <DoctorCard doctor={doctor} /> */}
      {showForm === "unregistered" && (
        <>
          <div
            style={{
              color: "rgba(0, 55, 113, 1)",
              fontSize: "24px",
              fontWeight: "500",
              marginBottom: "24px",
            }}
          >
            Please register before finalizing your booking
          </div>
          <form onSubmit={(e) => handleSubmit(e)}>
            <div className="registration-container w-100 d-flex flex-column gap-3">
              {isMobile ? (
                <>
                  <div className="row-1 d-flex flex-column align-items-center w-100">
                    <div className="d-flex align-items-center w-100 gap-1">
                      <div className="w-100" style={{ maxWidth: "107px" }}>
                        <div className="f500-14px">
                          Title
                          <span className="f500-16px text-danger">*</span>
                        </div>
                        <div>
                          <Select
                            name="Title"
                            options={dropdownOptions.Title}
                            value={{
                              label: formData.Title,
                              value: formData.Title,
                            }}
                            onChange={handleChange}
                            placeholder="Select Title"
                            styles={customStylesForNewRegistration}
                          />
                        </div>
                      </div>
                      <div className="w-100">
                        <div className="f500-14px">
                          Patient Name
                          <span className="f500-16px text-danger">*</span>
                        </div>
                        <div className="">First Name
                        <span className="f500-16px text-danger">*</span>
                          <input
                            type="text"
                            name="first_name"
                            value={formData.first_name}
                            onChange={handleChange}
                            required
                            placeholder="First Name"
                            style={inputStyles}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="w-100">
                      <div className="f500-14px">Middle Name</div>
                      <div className="">
                        <input
                          type="text"
                          name="middle_name"
                          value={formData.middle_name}
                          onChange={handleChange}
                          required={false}
                          placeholder="Middle Name"
                          style={inputStyles}
                        />
                      </div>
                    </div>
                    <div className="w-100">
                      <div className="f500-14px">
                        Last Name
                        <span className="f500-16px text-danger">*</span>
                      </div>
                      <div className="">
                        <input
                          type="text"
                          name="last_name"
                          value={formData.last_name}
                          onChange={handleChange}
                          required
                          placeholder="Last Name"
                          style={inputStyles}
                        />
                      </div>
                    </div>
                    <div className="w-100">
                      <div className="f500-14px">
                        Mobile
                        <span className="f500-16px text-danger">*</span>
                      </div>
                      <div>
                        <input
                          type="text"
                          name="patient_phone"
                          value={formData.patient_phone}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (!isNaN(value) && value.length <= 10) {
                              handleChange(e);
                            }
                          }}
                          placeholder="Mobile"
                          required
                          style={inputStyles}
                        />
                      </div>
                    </div>
                    <div className="d-flex align-items-center w-100 gap-1">
                      <div className="w-100" style={{ maxWidth: "170px" }}>
                        <div className="f500-14px">
                          Gender
                          <span className="f500-16px text-danger">*</span>
                        </div>
                        <div>
                          <Select
                            options={dropdownOptions.gender}
                            value={{
                              label: formData.gender,
                              value: formData.gender,
                            }}
                            onChange={handleChange}
                            placeholder="Select Gender"
                            styles={customStylesForNewRegistration}
                          />
                        </div>
                      </div>
                      <div className="w-100">
                        <div className="f500-14px">
                          Date of Birth
                          <span className="f500-16px text-danger">*</span>
                        </div>
                        <div>
                          <input
                            type="date"
                            name="DOB"
                            value={formData.DOB}
                            onChange={handleChange}
                            required
                            style={inputStyles}
                            max={new Date().toISOString().split("T")[0]}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="w-100">
                      <div className="f500-14px">
                        Email
                        <span className="f500-16px text-danger">*</span>
                      </div>
                      <div>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Email ID"
                          required
                          style={inputStyles}
                        />
                      </div>
                    </div>
                    <div className="w-100">
                      <div className="f500-14px">
                        Address
                        <span className="f500-16px text-danger">*</span>
                      </div>
                      <div>
                        <input
                          type="textarea"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          placeholder="address"
                          required
                          style={inputStyles}
                        />
                      </div>
                    </div>
                    <div className="w-100">
                      <div className="f500-14px">
                        Country
                        <span className="f500-16px text-danger">*</span>
                      </div>
                      <div>
                        <Select
                          options={dropdownOptions.country}
                          value={{
                            label: formData.country,
                            value: formData.country,
                          }}
                          onChange={async (e) => {
                            handleChange(e);
                            const lookupLink = await getLookupByName({
                              parentLookupName: "country",
                              parentListValue: e.value,
                            });
                            setStateLookupLinkName(lookupLink?.lookup_name);
                            setDropdownOptions((prevOptions) => ({
                              ...prevOptions,
                              state: lookupLink?.lookup_values?.map((item) =>
                                createOption({
                                  label: item.value,
                                  name: "state",
                                })
                              ),
                            }));
                          }}
                          placeholder="Select Country"
                          styles={customStylesForNewRegistration}
                        />
                      </div>
                    </div>
                    <div className="w-100">
                      <div className="f500-14px">
                        State
                        <span className="f500-16px text-danger">*</span>
                      </div>
                      <div>
                        <Select
                          options={dropdownOptions.state}
                          value={{
                            label: formData.state,
                            value: formData.state,
                          }}
                          onChange={async (e) => {
                            handleChange(e);
                            const lookupLink = await getLookupByName({
                              parentLookupName: stateLookupLinkName,
                              parentListValue: e.value,
                            });
                            setDropdownOptions((prevOptions) => ({
                              ...prevOptions,
                              district: lookupLink?.lookup_values?.map((item) =>
                                createOption({
                                  label: item.value,
                                  name: "district",
                                })
                              ),
                            }));
                            console.log(lookupLink, "Lookup Link");
                          }}
                          placeholder="Select State"
                          styles={customStylesForNewRegistration}
                        />
                      </div>
                    </div>
                    <div className="w-100">
                      <div className="f500-14px">
                        District
                        <span className="f500-16px text-danger">*</span>
                      </div>
                      <div>
                        <Select
                          options={dropdownOptions.district}
                          value={{
                            label: formData.district,
                            value: formData.district,
                          }}
                          onChange={handleChange}
                          placeholder="Select District"
                          styles={customStylesForNewRegistration}
                        />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div
                    className="row-1 d-flex align-items-center justify-content-between w-100"
                    // style={{ gap: "56px" }}
                  >
                    <div style={{ flexBasis: "30%" }}>
                      <div className="f500-14px">
                        Title
                        <span className="f500-16px text-danger">*</span>
                      </div>
                      <div>
                        <Select
                          name="Title"
                          options={dropdownOptions.Title}
                          value={{
                            label: formData.Title,
                            value: formData.Title,
                          }}
                          onChange={handleChange}
                          placeholder="Select Title"
                          styles={customStylesForNewRegistration}
                        />
                      </div>
                    </div>
                    <div style={{ flexBasis: "65%" }}>
                      <div className="f500-14px">
                        Patient Name
                        <span className="f500-16px text-danger">*</span>
                      </div>
                      <div className="d-flex gap-3">
                        <input
                          type="text"
                          name="first_name"
                          value={formData.first_name}
                          onChange={handleChange}
                          required
                          placeholder="First Name"
                          style={inputStyles}
                        />
                        <input
                          type="text"
                          name="middle_name"
                          value={formData.middle_name}
                          onChange={handleChange}
                          required={false}
                          placeholder="Middle Name"
                          style={inputStyles}
                        />
                        <input
                          type="text"
                          name="last_name"
                          value={formData.last_name}
                          onChange={handleChange}
                          required
                          placeholder="Last Name"
                          style={inputStyles}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="row-2 d-flex align-items-center justify-content-between"
                    // style={{ gap: "56px" }}
                  >
                    <div style={{ flexBasis: "30%" }}>
                      <div className="f500-14px">
                        Mobile
                        <span className="f500-16px text-danger">*</span>
                      </div>
                      <div>
                        <input
                          type="text"
                          name="patient_phone"
                          value={formData.patient_phone}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (!isNaN(value) && value.length <= 10) {
                              handleChange(e);
                            }
                          }}
                          placeholder="Mobile"
                          required
                          style={inputStyles}
                        />
                      </div>
                    </div>
                    <div style={{ flexBasis: "30%" }}>
                      <div className="f500-14px">
                        Gender
                        <span className="f500-16px text-danger">*</span>
                      </div>
                      <div>
                        <Select
                          options={dropdownOptions.gender}
                          value={{
                            label: formData.gender,
                            value: formData.gender,
                          }}
                          onChange={handleChange}
                          placeholder="Select Gender"
                          styles={customStylesForNewRegistration}
                        />
                      </div>
                    </div>
                    <div style={{ flexBasis: "30%" }}>
                      <div className="f500-14px">
                        Date of Birth
                        <span className="f500-16px text-danger">*</span>
                      </div>
                      <div>
                        <input
                          type="date"
                          name="DOB"
                          value={formData.DOB}
                          onChange={handleChange}
                          required
                          style={inputStyles}
                          max={new Date().toISOString().split("T")[0]}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row-3 d-flex align-items-center justify-content-between">
                    <div style={{ flexBasis: "30%" }}>
                      <div className="f500-14px">
                        Email
                        <span className="f500-16px text-danger">*</span>
                      </div>
                      <div>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Email ID"
                          required
                          style={inputStyles}
                        />
                      </div>
                    </div>
                    <div style={{ flexBasis: "65%" }}>
                      <div className="f500-14px">
                        Address
                        <span className="f500-16px text-danger">*</span>
                      </div>
                      <div>
                        <input
                          type="textarea"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          placeholder="address"
                          required
                          style={inputStyles}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="row-4 d-flex align-items-center justify-content-start w-100"
                    style={{ gap: "56px" }}
                  >
                    <div className="" style={{ flexBasis: "30%" }}>
                      <div className="f500-14px">
                        Country
                        <span className="f500-16px text-danger">*</span>
                      </div>
                      <div>
                        <Select
                          options={dropdownOptions.country}
                          value={{
                            label: formData.country,
                            value: formData.country,
                          }}
                          onChange={async (e) => {
                            handleChange(e);
                            const lookupLink = await getLookupByName({
                              parentLookupName: "country",
                              parentListValue: e.value,
                            });
                            setStateLookupLinkName(lookupLink?.lookup_name);
                            setDropdownOptions((prevOptions) => ({
                              ...prevOptions,
                              state: lookupLink?.lookup_values?.map((item) =>
                                createOption({
                                  label: item.value,
                                  name: "state",
                                })
                              ),
                            }));
                          }}
                          placeholder="Select Country"
                          styles={customStylesForNewRegistration}
                        />
                      </div>
                    </div>
                    <div className="" style={{ flexBasis: "30%" }}>
                      <div className="f500-14px">
                        State
                        <span className="f500-16px text-danger">*</span>
                      </div>
                      <div>
                        <Select
                          options={dropdownOptions.state}
                          value={{
                            label: formData.state,
                            value: formData.state,
                          }}
                          onChange={async (e) => {
                            handleChange(e);
                            const lookupLink = await getLookupByName({
                              parentLookupName: stateLookupLinkName,
                              parentListValue: e.value,
                            });
                            setDropdownOptions((prevOptions) => ({
                              ...prevOptions,
                              district: lookupLink?.lookup_values?.map((item) =>
                                createOption({
                                  label: item.value,
                                  name: "district",
                                })
                              ),
                            }));
                            console.log(lookupLink, "Lookup Link");
                          }}
                          placeholder="Select State"
                          styles={customStylesForNewRegistration}
                        />
                      </div>
                    </div>
                    <div className="" style={{ flexBasis: "30%" }}>
                      <div className="f500-14px">
                        District
                        <span className="f500-16px text-danger">*</span>
                      </div>
                      <div>
                        <Select
                          options={dropdownOptions.district}
                          value={{
                            label: formData.district,
                            value: formData.district,
                          }}
                          onChange={handleChange}
                          placeholder="Select District"
                          styles={customStylesForNewRegistration}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="d-flex justify-content-center flex-column align-items-center mt-1 gap-4 py-2">
              <div className="d-flex align-items-start w-100 justify-content-center gap-2">
                <div class="checkbox-wrapper-19">
                  <input
                    type="checkbox"
                    name="consent"
                    id="cbtest-19"
                    checked={formData.consent}
                    onChange={handleChange}
                  />
                  <label for="cbtest-19" class="check-box"></label>
                </div>
                <div className="f500-14px">
                  I have read & agree to the <span>Terms & Conditions</span>
                </div>
              </div>
              <div className="d-flex gap-4 align-items-center justify-content-center w-100">
                <div
                  className="w-100 back-button"
                  onClick={() => setShowForm("")}
                >
                  Back
                </div>
                <button
                  type="submit"
                  className="w-100 submit-button"
                  onClick={(e) => {
                    // e.preventDefault();
                    handleSubmit(e);
                    // setIsModalOpen(true);
                  }}
                >
                  Submit
                </button>
              </div>
              {/* {console.log("isModalOpen", isModalOpen)} */}
            </div>
          </form>
        </>
      )}
      <ReusableModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
        }}
        setShowPaymentModal={setShowPaymentModal}
        bgColor={"#fff"}
        borderRadius={"10px"}
        closeTimer={3000}
      >
        <div className="d-flex align-items-center flex-column">
          <div className="d-flex justify-content-center">{succesBtnSvg()}</div>
          <div className="fw-bold" style={{ fontSize: "21px" }}>
            New Registration Successful
          </div>
          <div style={{ fontSize: "16px" }}>
            Now you can proceed with the payment.
          </div>
        </div>
        {/* <AppointmentSuccess /> */}
      </ReusableModal>
      {isMobile && showForm === "payment" ? (
        <PaymentMobileComponent
          handleBookAppointment={handleBookAppointment}
          setShowForm={setShowForm}
          isAppointmentSuccessful={isAppointmentSuccessful}
        />
      ) : (
        <PaymentModal
          showPaymentModal={showPaymentModal}
          toggleModal={() => setShowPaymentModal(false)}
          handleBookAppointment={handleBookAppointment}
          isAppointmentSuccessful={isAppointmentSuccessful}
        />
      )}
    </div>
  );
}

export default NewPatientForm;
